import React,{useState} from 'react'
import { Card,Button, CardBody, CardHeader, CardText, CardTitle,Label } from 'reactstrap'
import Switch from "react-switch";
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import DatePicker from 'react-datepicker';
import { deviceOn,deviceTimerStart,deviceTimerEnd } from 'network/ApiAxiosAutomation';
import ToastComp from 'components/Reusable Components/ToastComp';

function DeviceCard(props) {
    const [startDate, setStartDate] = useState(props.device.schedule ? props.device.schedule.start :new Date());
    const [endDate, setEndDate] = useState(props.device.schedule ? props.device.schedule.end :new Date());
    const [checked, setChecked] = useState(props.device.status);
    const [scheduleChecked, setScheduleChecked] = useState(props.device.schedule);
    const [openResp, setopenResp] = useState(false);
    const [toast, setToast] = useState(false);

    const userID = JSON.parse(localStorage.getItem("user"))._id;

    const openDoor = async()=>{
        const resp = await deviceOn(props.device._id,userID)
        if(resp.data.success){
            setopenResp(true)
        }
    }

    const handleStartTime = async(time)=>{
        const resp = await deviceTimerStart(props.device._id,time)
        if(resp.data.success){
            setToast({title:'Start Time',text:'The start time has been saved'})
        }
    } 

    const handleEndTime = async(time)=>{
        const resp = await deviceTimerEnd(props.device._id,time)
        if(resp.data.success){
            setToast({title:'End Time',text:'The end time has been saved'})
        }
    } 

  return (
    <Card className='mb-2' outline style={{ width: '18rem' }}>
        <CardHeader className='bg-transparent' >
            <CardTitle>
                {props.device.name}
                <EmojiObjectsIcon fontSize="large" className=' float-right' style={{ color: 'Yellow' }}/>
            </CardTitle>
        </CardHeader>
        {props.device.type == 'switch' ?  
        <CardBody>
            <CardText>
                <Label>
                    Status:
                    <Switch onChange={()=>setChecked(!checked)} checked={checked} />
                </Label>
            </CardText>
            <CardText>
                <Label>
                    Schedule:
                    <Switch onChange={()=>setScheduleChecked(!scheduleChecked)} checked={scheduleChecked} />
                </Label>
                {scheduleChecked && <>
                    <br/>
                    <Label>
                        On:
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => {setStartDate(date);handleStartTime(date)}}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={30}
                            timeCaption="Start Time"
                            dateFormat="h:mm aa"
                        />
                    </Label>
                    <Label>
                        Off:
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => {setEndDate(date);handleEndTime(date)}}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={30}
                            timeCaption="End Time"
                            dateFormat="h:mm aa"
                        />
                    </Label>
                </>}
            </CardText>
        </CardBody>
        :
        <CardBody>
            <CardText>
                <Label>
                    <Button onClick={openDoor} className={openResp && 'bg-green'} >Open Door</Button>
                </Label>
            </CardText>
        </CardBody>}
        {toast && <ToastComp type='primary' title={toast.title} text={toast.text} />}
    </Card>
  )
}

export default DeviceCard